import React from 'react';
import { roundigFormat } from '../libs/utils/Operations';
import moment from "moment";
import { CURRENCY } from '../libs/utils/Const';

//formato de cantidades 
var formatNumber = {
    separador: ",", // separador para los miles
    sepDecimal: '.', // separador para los decimales
    formatear: function (num) {
        num += '';
        var splitStr = num.split('.');
        var splitLeft = splitStr[0];
        var splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        var regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },
    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    }
}

const renderTableBody = (headers, data, checkbox, openDocumentDetails) => {
    let body = "";
    body = data && data.length > 0 && data.map((register, index) => {
        let document = {};
        if (register.CANCELED === 'Y') {
            document.status = 'Cancelado'
            document.color = 'red';
        } else if (register.U_UDF_UUID) {
            document.status = 'Timbrado';
            if (register.DocStatus === 'O') {
                document.color = 'black';
            } else {
                document.color = 'red';
            }
            document.disable = false;
        } else if (register.DocStatus === 'C' && register.InvntSttus === 'O' && register.DocTotal === register.PaidToDate) {
            document.color = 'black';
            document.status = "Pagado";
            document.disable = false;
        } else if (register.DocStatus === 'C') {
            document.color = 'red';
            document.status = 'Cerrado';
            document.disable = false;
        } else if (register.DocStatus === 'O') {
            document.color = 'black';
            document.status = 'Abierto';
            document.disable = false;
        }

        let DocCur = register?.DocCur || CURRENCY || '';
        let DocTotal = (!DocCur || DocCur === 'SOL')
            ? Number(register?.DocTotal || 0)
            : Number(register?.DocTotalFC || 0);

        DocTotal = Number.isFinite(DocTotal) ? DocTotal : 0;

        return (
            <tr key={index}>
                <td className="sticky-column" >
                    <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" disabled={document.disable} checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)} />
                </td>

                {headers[0].value && <td>{register.Series}</td>}
                {headers[1].value && <td style={{ color: document.color }}>{document.status}</td>}
                {headers[2].value && <td className="text-right font-weight-bold">{register.DocNum}</td>}
                {headers[3].value && <td>{register.CardCode}</td>}
                {headers[4].value && <td>{register.CardName}</td>}
                {headers[5].value && <td style={{ textAlign: 'Center' }}>{moment(register.DocDate).utc().format('DD-MM-YYYY')}</td>}
                {headers[6].value && <td>{register.Comments === 0 || register.Comments === 'undefined' || register.Comments === undefined || register.Comments === '' || register.Comments === null ? "No hay comentarios" : register.Comments}</td>}
                {headers[7].value && <td>{register.SlpCode || ''}</td>}
                {headers[8].value && <td>{register.OwnerCode || ''}</td>}
                {/* {headers[9].value && <td className="text-right font-weight-bold">{CURRENCY + ' ' + Number(register.DocTotal).toFixed(2)}</td>} */}
                {headers[9].value && <td className="text-right font-weight-bold">{`${DocCur} ${formatNumber.new(DocTotal)}`}</td>}
                {headers[10].value && <td style={{ textAlign: 'Center' }}>{moment(register.DocDueDate).utc().format('DD-MM-YYYY')}</td>}
                {headers[11].value && <td className="text-center font-weight-bold" style={{ textAlign: 'Center' }}>{register.NumAtCard || ''}</td>}
                {headers[12].value && <td>{register.U_STR_ObsEst || ''}</td>}
                {headers[13].value && <td>{register.U_STR_Estado || ''}</td>}
                {headers[14].value && <td className="text-right ">{roundigFormat(register.DocsVencidos)}</td>}
                {headers[15].value && <td className="text-right ">{CURRENCY + ' ' + (register.Facturado === 0 || register.Facturado <= '0' || register.Facturado === null || register.Facturado === NaN || register.Facturado === 'undefined' || register.Facturado === undefined || register.Facturado === "" ? "0.00" : Number(register.Facturado).toFixed(2))}</td>}
                {headers[16].value && <td className="text-right text-success">{CURRENCY + ' ' + (register.Pagado === 0 || register.Pagado <= '0' || register.Pagado === null || register.Pagado === NaN || register.Pagado === 'undefined' || register.Pagado === undefined || register.Pagado === "" ? "0.00" : Number(register.Pagado).toFixed(2))}</td>}
                {headers[17].value && <td className="text-right text-danger">{CURRENCY + ' ' + (register.MontoVencido === 0 || register.MontoVencido <= '0' || register.MontoVencido === null || register.MontoVencido === NaN || register.MontoVencido === 'undefined' || register.MontoVencido === undefined || register.MontoVencido === "" ? "0.00" : Number(register.MontoVencido).toFixed(2))}</td>}

                <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }} >
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect" onClick={() => openDocumentDetails({...register, index })} style={{ fontWeight: '500' }}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>

        )
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDocumentDetails) => {
    let header = "";
    let body = "";

    if (headers && headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{ backgroundColor: "#e9ecef" }}>
                <input type="checkbox" style={{ minWidth: '100%' }} id="cbox2" value="second_checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)} />
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            {headers[7].value && <td>{headers[7].title}</td>}
            {headers[8].value && <td>{headers[8].title}</td>}
            {headers[9].value && <td>{headers[9].title}</td>}
            {headers[10].value && <td>{headers[10].title}</td>}
            {headers[11].value && <td>{headers[11].title}</td>}
            {headers[12].value && <td>{headers[12].title}</td>}
            {headers[13].value && <td>{headers[13].title}</td>}
            {headers[14].value && <td>{headers[14].title}</td>}
            {headers[15].value && <td>{headers[15].title}</td>}
            {headers[16].value && <td>{headers[16].title}</td>}
            {headers[17].value && <td>{headers[17].title}</td>}
            <td className="sticky-columns" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDocumentDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableInvoice = (headers, data, checkbox, openDocumentDetails) => {

    return renderTable(headers, data, checkbox, openDocumentDetails);

}